import React, { FC } from 'react';
import { CurrentCategoryContext } from './CurrentCategoryContext';
import type { CurrentCategoryProviderProps } from './CurrentCategoryProvider.types';

export const CurrentCategoryProvider: FC<CurrentCategoryProviderProps> = ({ category, children }) => (
  <CurrentCategoryContext.Provider value={{ category }}>{children}</CurrentCategoryContext.Provider>
);
